import * as React from 'react';
import cx from 'classnames';

import { Typography } from 'antd';

import styles from './RolesView.scss';

const { Title } = Typography;

interface IProps {
  className?: string;
}

/**
 * @type {React.FunctionComponent}
 */
const RolesView: React.FunctionComponent<React.PropsWithChildren<IProps>> = React.memo((props) => {
  return (
    <div className={cx(styles.RolesView, props.className)}>
      <div>
        <Title>Roles</Title>
      </div>
    </div>
  );
});

export default RolesView;
